define(['moduler'], function (Moduler) {
    'use strict';
    /*
     * lazy loader for background-image image styling elements
     */
    var LazyLoad = {};
    LazyLoad.utils = {
        fadeIn: function (el, time, callback) {
            var maxOpacity = el.getAttribute('data-lazyloading-opacity');
            if (time == 0) {
                el.style.opacity = maxOpacity;
                if (callback) {
                    callback();
                }
                return;
            }
            el.style.opacity = 0;
            var last = +new Date();
            var tick = function () {
                el.style.opacity = +el.style.opacity + (new Date() - last) / time;
                last = +new Date();
                if (+el.style.opacity < maxOpacity) {
                    (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
                } else {
                    if (callback) {
                        callback();
                    }
                }
            };
            tick();
        },
        fadeOut: function (el, time, callback) {
            if (time == 0) {
                el.style.opacity = 0;
                if (callback) {
                    callback();
                }
                return;
            }
            var maxOpacity = el.getAttribute('data-lazyloading-opacity');
            el.style.opacity = maxOpacity;
            var last = +new Date();
            var tick = function () {
                el.style.opacity = +el.style.opacity - (new Date() - last) / time;
                last = +new Date();
                if (+el.style.opacity > 0) {
                    (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
                } else {
                    el.style.opacity = 0;
                    if (callback) {
                        callback();
                    }
                }
            };
            tick();
        }
    };

    return Moduler.create({
        defaults: {
            imageUrl: null,
            loading: null, // set to 'lazy' to also consider the element itself 
            loadingAttribute: 'data-loading',
            fadeTime: 200
        },

        setElementImage: function (element) {
            var self = this;
            var attr = element.getAttribute('data-lazyloading');
            var imgData = attr
                ? Moduler.utils.parseSettings(attr).imageUrl
                : self.options.imageUrl;
                                
            element.style.backgroundImage = 'url(' + imgData + ')';
        },

        init: function () {
            var self = this;
            var intersectionObserver = new IntersectionObserver(entries => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio > 0) {
                        var load = function () {
                            var opacity = window.getComputedStyle(entry.target).opacity;
                            entry.target.setAttribute('data-lazyloading-opacity', opacity);
                            LazyLoad.utils.fadeOut(entry.target, self.options.fadeTime, function () {
                                self.setElementImage(entry.target);
                                LazyLoad.utils.fadeIn(entry.target, self.options.fadeTime);
                            });
                        };
                        (window.requestIdleCallback && requestIdleCallback(load)) || setTimeout(load, 0);
                        intersectionObserver.unobserve(entry.target);
                    }
                });
            });

            // reset
            intersectionObserver.disconnect();
            // start observing
            var elements = self.el.querySelectorAll('[' + self.options.loadingAttribute + '="lazy"]');
            if (self.el.getAttribute(self.options.loadingAttribute) == 'lazy' || self.options.loading == 'lazy') {
                elements = [self.el, ...elements];
            }

            elements.forEach(element => {
                var rect = element.getBoundingClientRect();
                if (rect.top >= 0 && rect.top < window.innerHeight) {
                    self.setElementImage(element);
                } else {
                    intersectionObserver.observe(element);
                }
            });
        }
    });
});